export default __webpack_public_path__ + "locales/si/EmptyTrashDialog.json?hash=03535de1407bee7232bae60663f352f5";